const isDarkContext = (vm) => {
  const layoutDark = vm?.$store?.state?.layout?.darkMode
  const vuetifyDark = vm?.$vuetify?.theme?.dark
  return vm?.inDarkMode === true || layoutDark === true || vuetifyDark === true
}

export default {
  methods: {
    isDarkThemeContext() {
      return isDarkContext(this)
    },

    themeTextClass(lightText = 'black', darkText = 'white') {
      return `${this.isDarkThemeContext() ? darkText : lightText}--text`
    },

    themeSurfaceColor(lightColor = 'offwhite', darkColor = 'black') {
      return this.isDarkThemeContext() ? darkColor : lightColor
    },

    themeButtonColor({
      active = false,
      activeLight = 'primary',
      activeDark = 'primary',
      idleLight = 'default',
      idleDark = 'nearblack',
    } = {}) {
      if (active) {
        return this.isDarkThemeContext() ? activeDark : activeLight
      }
      return this.isDarkThemeContext() ? idleDark : idleLight
    },
  },
}
